namespace $ {

	$mol_style_define( $shm_hitalama_map_rights, {

		padding: 0,
		gap: 0,
		flexDirection: 'column',
		width: '100%',
		maxWidth: '100vw',

		Team_member: {
			flex: { grow: 1 },
			minWidth: 0,
		},

		Actions: {
			gap: $mol_gap.text,
			flex: {
				wrap: 'wrap',
			},
		},

		Access_title: {
			font: { weight: 'bold' },
			border: {
				top: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
			padding: $mol_gap.text,
		},

		Access_list: {
			padding: 0,
			gap: $mol_gap.block,
		},

		Access_row: {
			flexDirection: 'column',
			gap: $mol_gap.text,
			padding: $mol_gap.text,
			border: { radius: $mol_gap.round },
			boxShadow: `inset 0 0 0 1px ${ $mol_theme.line }`,
			background: { color: $mol_theme.card },
		},

		Access_identity: {
			flexDirection: 'column',
			minWidth: 0,
		},

		Access_actions: {
			alignItems: 'center',
			justifyContent: 'space-between',
			flex: { wrap: 'wrap' },
		},

		Access_person: {
			flex: { grow: 1 },
			minWidth: 0,
		},

		Access_id: {
			color: $mol_theme.shade,
			overflowWrap: 'anywhere',
		},

	} )

}
